import React from 'react';
import { withRouter } from 'react-router-dom';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';
import NavigationItems from '../../components/Navigation/NavigationItems/NavigationItems';
import Button from '../../components/UI/Button/Button';
import classes from './Footer.module.css';
// import { render } from '@testing-library/react';
import { Component } from 'react';
import copyRight from '../../assets/images/copyright2021.gif';

class Footer extends Component {
    fbClicked = () => {
        window.open('https://www.facebook.com/sweetorsalted');
    }
    emailClicked = () => {
        // console.log('this.props.history', this.props.history);
        this.props.history.push('/contactForm');
    }
    // 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
    render(){
        let imgClasses = [classes.CopyRightImg, classes.Filter];
        return (
            <Aux>
                <div className={classes.SocialMedia}>
                    <Button clicked={this.fbClicked}>
                        <FontAwesomeIcon className={classes.FaIcon} icon={['fab', 'facebook']} />
                    </Button>
                    <Button>
                        <FontAwesomeIcon className={classes.FaIcon} icon={['fab', 'instagram']} />
                    </Button>
                    <Button>
                        <FontAwesomeIcon className={classes.FaIcon} icon={['fab', 'pinterest']} />
                    </Button>
                    <Button btnType="Success" clicked={this.emailClicked} className={classes.Contacts}>
                        <FontAwesomeIcon className={classes.FaIcon} icon="at" />
                    </Button>
                </div>
                <div className={classes.FooterLinksWrapper}>
                    <div className={classes.RightsReserved}>
                        <img src={ copyRight } className={imgClasses.join(' ')} alt="Vsichki prava zapazeni ot Sladko ili Soleno 2021" />
                    </div>
                    <NavigationItems footer />
                </div>
            </Aux>
        )
    }
}
// envelope
export default withRouter(Footer);